import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900" }
const _hoisted_2 = { class: "container px-6 py-16 mx-auto" }
const _hoisted_3 = { class: "items-center lg:flex" }
const _hoisted_4 = { class: "w-full lg:w-1/2" }
const _hoisted_5 = { class: "lg:max-w-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-semibold text-gray-800 dark:text-white lg:text-4xl" }, [
  /*#__PURE__*/_createTextVNode(" Best place to choose "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" your "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple-500" }, "online products.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 text-gray-600 dark:text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" With online store like our your shopping experience is personalized to your styleand sense of fashion. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" We got you covered all the way. We're here to meet your need for whatever intests you in buying. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "w-full px-5 py-2 mt-6 text-sm tracking-wider text-white uppercase transition-colors duration-300 transform bg-purple-600 rounded-lg lg:w-auto hover:bg-purple-500 focus:outline-none focus:bg-purple-500" }, " Shop Now ", -1)
const _hoisted_9 = { class: "flex items-center justify-center w-full mt-6 lg:mt-0 lg:w-1/2" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_router_link, { to: "shop" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            class: "w-full h-full lg:max-w-3xl",
            src: require('public/shopping.svg'),
            alt: "shopping"
          }, null, 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}